import { coreAPI } from "../../axios";
export const actions = {
    getAllServicesByDeliveryUnit(context, data){
        return coreAPI.get(`DeliveryUnitService/DeliveryUnit/${data}`);
    },
    getDeliveryUnitServicesByCampus(context, data){
        return coreAPI.get(`DeliveryUnitService/Campus/${data}`);
    },
    getDeliveryUnitServicesByDU(context, data){
        return coreAPI.get(`DeliveryUnitService/DeliveryUnit/${data}`);
    },
    getSingleDeliveryUnitService(context, data){
        return coreAPI.get(`DeliveryUnitService/${data}`);
    },
    createDeliveryUnitService(context, data){
        return coreAPI.post(`DeliveryUnitService/Create`, data);
    },
    updateDeliveryUnitService(context, data){
        return coreAPI.put(`DeliveryUnitService/Update/${data.id}`, data);
    },
    deleteDeliveryUnitService(context, data){
        return coreAPI.delete(`DeliveryUnitService/Delete/${data}`);
    }
}
